import { Component } from '@angular/core';
import { ModalService } from '@lsq-frontend/common-ui';

@Component({
    selector: 'verify-supplier-upload-modal',
    template: `
        <div class="modal-body toggle-supplier-eligibility-modal">
            <p class="bottom-margin">
                Please confirm that the information outlined below is correct.
            </p>
            <data-card class="bottom-margin">
                <div class="data-header">Buyer Relationship</div>
                <div class="data-value">{{ buyerName }}</div>
            </data-card>
            <br />
            <data-card class="bottom-margin">
                <div class="data-header">CSV Filename</div>
                <div class="data-value">{{ fileName }}</div>
            </data-card>
        </div>
    `
})
export class VerifySupplierUploadModalComponent {
    public buyerName: string;
    public fileName: string;
    constructor(private _modalService: ModalService) {
        const modalData = this._modalService.modal.data;
        this.fileName = modalData.fileName;
        this.buyerName = modalData.buyerName;
    }
}
